import React from 'react';

interface InputProps {
  type?: 'text' | 'email' | 'tel' | 'password' | 'number' | 'date';
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  required?: boolean;
  disabled?: boolean;
  autoComplete?: string;
  id?: string;
  name?: string;
  label?: string;
  error?: string;
  className?: string;
  fullWidth?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export default function Input({
  type = 'text',
  placeholder,
  value,
  onChange,
  onBlur,
  onFocus,
  required = false,
  disabled = false,
  autoComplete,
  id,
  name,
  label,
  error,
  className = '',
  fullWidth = true,
  size = 'md'
}: InputProps) {
  const baseClasses = 'border border-border-light rounded-md focus:ring-2 focus:ring-trust-blue/20 focus:border-trust-blue transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed';

  const sizeClasses = {
    sm: 'px-3 py-2 text-supporting',
    md: 'px-4 py-3 text-body-lg',
    lg: 'px-5 py-4 text-body-lg'
  };

  const widthClass = fullWidth ? 'w-full' : '';
  const errorClass = error ? 'border-error-red focus:border-error-red focus:ring-error-red/20' : '';

  const inputClasses = `${baseClasses} ${sizeClasses[size]} ${widthClass} ${errorClass} ${className}`;

  return (
    <div className={fullWidth ? 'w-full' : ''}>
      {label && (
        <label
          htmlFor={id}
          className="block text-supporting font-medium text-gray-700 mb-2"
        >
          {label}
          {required && <span className="text-error-red ml-1">*</span>}
        </label>
      )}

      <input
        type={type}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        autoComplete={autoComplete}
        className={inputClasses}
      />

      {error && (
        <p className="text-error-red text-supporting mt-1">
          {error}
        </p>
      )}
    </div>
  );
}